import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { SEARCH_ORIGINATIONS } from 'constants/search';
import SearchPageContainer from 'containers/SearchPageContainer';
import Log from 'utils/Log';
import Rudderstack from 'utils/Rudderstack';
import { parseQueryString } from 'utils/Url';

const SearchPageController = class {
  static get windowData() {
    const data = get(window, ['ALLBIRDS', 'searchPage']);

    if (!data) {
      Log.error(new Error('Controllers:SearchPageController.windowData -- missing window data!'));
    }

    return data;
  }

  static trackProductsSearchInitiated() {
    const urlParams = parseQueryString();
    const { origin } = urlParams;

    // The URL query param being 'origin' defined indicates that the search page
    // was navigated to from the Quick Search feature. To avoid double
    // counting search initiation, we shouldn't send a Search Initiated
    // event if a user opens the search page from Quick Search.
    // Deep link used by CM team does not contains this 'origin' query param
    if (!origin) {
      Rudderstack.productsSearchInitiated({
        searchSource: window.location.href,
        searchEntry: SEARCH_ORIGINATIONS.SEARCH_PAGE,
      });
    }
  }

  static mountSearchPage = store => {
    ReactDOM.render(
      <Provider store={store}>
        <SearchPageContainer />
      </Provider>,
      document.getElementById('search-container')
    );
  };

  static init = store => {
    SearchPageController.mountSearchPage(store);
    SearchPageController.trackProductsSearchInitiated();
  };
};

export default SearchPageController;
